import { Navigate } from 'react-router-dom'
import React from 'react'

import { LocalStorageKeys, RoutesPath } from 'src/types'

interface AuthLayoutProps {
  children: React.ReactNode
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const isAuthenticated = localStorage.getItem(LocalStorageKeys.AUTH_TOKEN)

  return (
    <div className="auth-layout">
      <main>
        {!isAuthenticated ? children : <Navigate to={RoutesPath.HOME} />}
      </main>
    </div>
  )
}

export default AuthLayout
